import { render, staticRenderFns } from "./ConsultarPermissoes.vue?vue&type=template&id=a57e2b54"
import script from "./ConsultarPermissoes.vue?vue&type=script&lang=ts"
export * from "./ConsultarPermissoes.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports